// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import scrubPathSummary from 'components/PathSummary/prepData/scrubPathSummary'
import { fetchPathSummaryById } from 'helpers/api'

const fetchAndScrubSinglePath = async (pathId, pathIndex, unitType) => {
  const { entity } = await fetchPathSummaryById(pathId)
  return scrubPathSummary(entity, pathIndex, unitType)
}

export default fetchAndScrubSinglePath
